import { Typography } from 'bento';
import { css } from '@emotion/react';
import LinkButton from '@tock/shared/components/buttons/LinkButton';

interface Props {
  lastNameFirstName: string;
  partySize: number;
  openPartyFullPanel: () => void;
}

const PartyPopoverHeader: React.FC<React.PropsWithChildren<Props>> = ({
  lastNameFirstName,
  partySize,
  openPartyFullPanel,
}) => {
  return (
    <div
      data-testid="popover-header"
      css={css`
        display: flex;
        justify-content: space-between;
        padding-bottom: 1rem;
      `}
    >
      <LinkButton onClick={openPartyFullPanel}>
        <Typography
          variant="heading04"
          css={css`
            text-decoration: underline;
          `}
        >
          {lastNameFirstName}
        </Typography>
      </LinkButton>

      <Typography variant="heading04">{partySize}</Typography>
    </div>
  );
};

export default PartyPopoverHeader;
